// Data lives in practiceAreas.json (not this file) so a plain Node build
// script can read it too, without needing to parse ES module syntax.
import practiceAreasData from './practiceAreas.json';

export const practiceAreas = practiceAreasData;

export function getPracticeAreaBySlug(slug) {
  return practiceAreas.find((area) => area.slug === slug);
}

export function getPracticeAreaByKey(key) {
  return practiceAreas.find((area) => area.key === key);
}
